'use client';

import { useEffect } from 'react';

const DATA_ATTR = 'data-swiftype-head';

type SwiftypeTag = {
  name: string;
  content: string;
  class: string;
  'data-type': string;
};

const BASE_TAGS: SwiftypeTag[] = [
  { class: 'swiftype', name: 'domain-identifier', content: '1', 'data-type': 'integer' },
  { class: 'swiftype', name: 'tags', content: 'academy', 'data-type': 'string' },
];

/**
 * Injects Swiftype meta tags into document.head on the client (for in-browser inspection).
 * The same tags are also in the initial HTML via generateMetadata's other (metadata.other).
 */
export function SwiftypeHead({ tags = [] }: { tags?: SwiftypeTag[] }) {
  const key = JSON.stringify(tags);

  useEffect(() => {
    if (typeof document === 'undefined' || !document.head) return;

    const all = [...BASE_TAGS, ...tags];
    const elements: HTMLMetaElement[] = [];

    all.forEach((tag) => {
      if (tag.content == null || String(tag.content).trim() === '') return;
      const meta = document.createElement('meta');
      meta.setAttribute('class', tag.class);
      meta.setAttribute('name', tag.name);
      meta.setAttribute('content', String(tag.content));
      meta.setAttribute('data-type', tag['data-type']);
      meta.setAttribute(DATA_ATTR, '1');
      document.head.appendChild(meta);
      elements.push(meta);
    });

    return () => {
      elements.forEach((el) => el.remove());
    };
  }, [key]);

  return null;
}
